
import UserManagement from "../../Components/UserManagement/UserManagement"

function UserManagementPage() {
    return <>
        <UserManagement />
    </>
}

export default UserManagementPage